import React, { useEffect, useState, useCallback, useMemo } from 'react'
import './LandingPage.css'
import Countdown from 'react-countdown'
import BNB_logo from '../Assets/polygon.png'
import usdt from '../Assets/USDT.png'
import usdc from '../Assets/USDC.png'
import in_logo from '../Assets/ip-logo.png'
import { FaWallet, FaShoppingCart, FaShareAlt, FaLock, FaUnlock } from 'react-icons/fa'
import { useAccount, useBalance, useNetwork, useSwitchNetwork } from 'wagmi'
import { useWeb3Modal } from '@web3modal/wagmi/react'
import { prepareWriteContract, waitForTransaction, writeContract } from '@wagmi/core'
import {
  preSale_Contract_ABI,
  preSale_Contract_Address,
  USDC_Contract_Abi,
  USDC_Contract_Address,
  USDT_Contract_Abi,
  USDT_Contract_Address,
} from '../../utilies/constant'
import { Staking_Address, Staking_Abi, Token_Address, Token_Abi } from '../../util/Contract2'
import Web3 from 'web3'
import toast from 'react-hot-toast'

const Completionist = () => <></>

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) return <Completionist />
  return (
    <div className="row timer_here">
      <div className="col-3">
        <h1 className="numbers">{days}</h1>
        <p className="days ss mb-0">DAY</p>
      </div>
      <div className="col-3">
        <h1 className="numbers">{hours}</h1>
        <p className="days ss mb-0">HOUR</p>
      </div>
      <div className="col-3">
        <h1 className="numbers">{minutes}</h1>
        <p className="days ss mb-0">MIN</p>
      </div>
      <div className="col-3">
        <h1 className="numbers">{seconds}</h1>
        <p className="days ss mb-0">SEC</p>
      </div>
    </div>
  )
}

export default function LandingPage() {
  const webSupply = useMemo(() => new Web3('https://polygon-rpc.com/'), [])
  const preSaleContract = useMemo(
    () => new webSupply.eth.Contract(preSale_Contract_ABI, preSale_Contract_Address),
    [webSupply],
  )
  const usdcContract = useMemo(
    () => new webSupply.eth.Contract(USDC_Contract_Abi, USDC_Contract_Address),
    [webSupply],
  )
  const usdtContract = useMemo(
    () => new webSupply.eth.Contract(USDT_Contract_Abi, USDT_Contract_Address),
    [webSupply],
  )
  const tokenContract = useMemo(
    () => new webSupply.eth.Contract(Token_Abi, Token_Address),
    [webSupply],
  )

  const { chain } = useNetwork()
  const { chains, switchNetwork } = useSwitchNetwork()
  const { address } = useAccount()
  const { open } = useWeb3Modal()
  const [plan, setplan] = useState(0)
  const [getBalance, setgetBalance] = useState(0)
  const [getBNB_value, setgetBNB_value] = useState('')
  const [showToken, setshowToken] = useState(0)
  const [spinner, setspinner] = useState(false)
  const [spinner2, setspinner2] = useState(false)
  const [refAddress, setRefAddress] = useState('')
  const [claimable, setclaimable] = useState(0)
  const [raiseUsdt, setusdtraised] = useState(0)
  const [soldTotal, setsoldTotal] = useState(0)
  const [totalreferearned, settotalreferearned] = useState(0)
  const [isclaim, setisclaimopen] = useState('')
  const [copied, setCopied] = useState(false)
  const [tokenClaimable, setClaimable] = useState(0)
  const [ReferralCount, setReferralCount] = useState(0)
  const [RefEarned, setReferralEarned] = useState(0)
  const [newSpinner, setnewSpinner] = useState(false)
  const [tokenPrice, setTokenPrice] = useState('0')
  const [ipBalance, setIpBalance] = useState('0') // New state for $IP balance

  const { data1 } = useBalance({ address, watch: true })

  const copyToClipboard = useCallback(() => {
    navigator.clipboard.writeText(refAddress)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }, [refAddress])

  const getNextPrice = useCallback((currentPrice) => {
    const priceStages = [0.00025, 0.0003, 0.00035, 0.0004, 0.00045]
    for (let i = 0; i < priceStages.length; i++) {
      if (currentPrice < priceStages[i]) return priceStages[i]
    }
    return priceStages[priceStages.length - 1]
  }, [])

  const contractData = useCallback(async () => {
    try {
      const isclaimopen = await preSaleContract.methods.IsClaim().call()
      setisclaimopen(isclaimopen)
    } catch (error) {
      console.log(error)
    }
  }, [preSaleContract])

  const balanceOf = useCallback(async () => {
    try {
      const tokenPricePerUSDT = await preSaleContract.methods.TokenPricePerUSDC().call()
      const formattedTokenPrice = (tokenPricePerUSDT / 1e6).toString()
      setTokenPrice(formattedTokenPrice)

      const soldTokenTotalRaw = await preSaleContract.methods.TokenSold().call()
      const soldTokenTotal = (soldTokenTotalRaw / 1e6).toString()
      setsoldTotal(soldTokenTotal)

      const USDTRaisedTotal = await preSaleContract.methods.totalUSDTRaised().call()
      const usdt = (USDTRaisedTotal / 1e6).toString()
      setusdtraised(usdt)

      if (address) {
        const [referralCount, referralEarned, claimableToken, ipTokenBalance] = await Promise.all([
          preSaleContract.methods.referralCount(address).call(),
          preSaleContract.methods.totalReferralEarningsInUSDT(address).call(),
          preSaleContract.methods.Claimable(address).call(),
          tokenContract.methods.balanceOf(address).call(), // Fetch $IP balance
        ])
        setReferralCount(referralCount)
        setReferralEarned((referralEarned / 1e18).toFixed(2))
        setclaimable(webSupply.utils.fromWei(claimableToken.toString()))
        setIpBalance((ipTokenBalance / 1e6).toString()) // Adjusted for 6 decimals

        let balanceValue
        if (plan === 0) {
          balanceValue = await webSupply.eth.getBalance(address)
          setgetBalance(webSupply.utils.fromWei(balanceValue.toString()))
        } else if (plan === 1) {
          balanceValue = await usdcContract.methods.balanceOf(address).call()
          setgetBalance((balanceValue / 1e6).toString())
        } else {
          balanceValue = await usdtContract.methods.balanceOf(address).call()
          setgetBalance((balanceValue / 1e6).toString())
        }
      }

      const valueBNB = webSupply.utils.toWei(getBNB_value || '0')
      let tokenAmount
      if (plan === 0) {
        tokenAmount = await preSaleContract.methods.MATICToToken(valueBNB).call()
        tokenAmount = webSupply.utils.fromWei(tokenAmount.toString())
      } else {
        tokenAmount = await preSaleContract.methods.getValuePerUSDC(valueBNB).call()
        tokenAmount = webSupply.utils.fromWei(tokenAmount.toString())
      }
      setshowToken(plan === 0 ? (tokenAmount * 1e12).toString() : tokenAmount)
    } catch (error) {
      console.log(error)
    }
  }, [
    address,
    plan,
    getBNB_value,
    preSaleContract,
    usdcContract,
    usdtContract,
    tokenContract,
    webSupply,
  ])

  const staking_Amount = useCallback(async () => {
    if (!getBNB_value) {
      toast.error('Please Enter Amount First!')
      setspinner(false)
      return
    }

    const formattedBalance = plan === 0 ? data1?.formatted : getBalance
    if (parseFloat(getBNB_value) > parseFloat(formattedBalance)) {
      toast.error('Insufficient Balance')
      setspinner(false)
      return
    }

    if (!address) {
      toast.error('Please Connect Your wallet First!')
      setspinner(false)
      return
    }

    setspinner(true)
    try {
      const queryString = window.location.search
      const parameters = new URLSearchParams(queryString)
      let RefferalAddress = parameters.get('ref') || '0x0000000000000000000000000000000000000000'
      const stakingValue = webSupply.utils.toWei(getBNB_value)

      if (plan === 0) {
        const { request } = await prepareWriteContract({
          address: preSale_Contract_Address,
          abi: preSale_Contract_ABI,
          functionName: 'BuyWithMatic',
          args: [RefferalAddress],
          value: stakingValue,
          account: address,
        })
        const { hash } = await writeContract(request)
        await waitForTransaction({ hash })
        toast.success('Purchase Successful')
      } else {
        const preSaleValue = stakingValue / 1e12
        const { request: approveRequest } = await prepareWriteContract({
          address: plan === 1 ? USDC_Contract_Address : USDT_Contract_Address,
          abi: plan === 1 ? USDC_Contract_Abi : USDT_Contract_Abi,
          functionName: 'approve',
          args: [preSale_Contract_Address, preSaleValue],
          account: address,
        })
        const { hash: approveHash } = await writeContract(approveRequest)
        await waitForTransaction({ hash: approveHash })

        toast.success('Approve Successful')
        const { request } = await prepareWriteContract({
          address: preSale_Contract_Address,
          abi: preSale_Contract_ABI,
          functionName: 'BuyWithUSDT',
          args: [preSaleValue, RefferalAddress],
          account: address,
        })
        const { hash } = await writeContract(request)
        await waitForTransaction({ hash })
        toast.success('Purchase Successful')
      }
    } catch (e) {
      console.log('Error', e)
      toast.error('Purchase failed')
    } finally {
      setspinner(false)
    }
  }, [
    address,
    getBNB_value,
    plan,
    data1,
    getBalance,
    preSaleContract,
    usdcContract,
    usdtContract,
    webSupply,
  ])

  const claim = useCallback(async () => {
    if (!isclaim) {
      toast.error('Presale is running!')
      setspinner2(false)
      return
    }

    setspinner2(true)
    try {
      const { request } = await prepareWriteContract({
        address: preSale_Contract_Address,
        abi: preSale_Contract_ABI,
        functionName: 'claim',
        args: [],
        account: address,
      })
      const { hash } = await writeContract(request)
      await waitForTransaction({ hash })
      toast.success('Claim Successful')
    } catch (e) {
      console.log('Error', e)
      toast.error('Claim failed')
    } finally {
      setspinner2(false)
    }
  }, [address, isclaim, preSaleContract])

  useEffect(() => {
    balanceOf()
    contractData()
    const interval = setInterval(() => {
      balanceOf()
      contractData()
    }, 30000)
    return () => clearInterval(interval)
  }, [balanceOf, contractData])

  useEffect(() => {
    if (address) {
      const baseUrl = window.location.origin + window.location.pathname
      setRefAddress(`${baseUrl}?ref=${address}`)
    } else {
      setRefAddress('Connect your wallet')
    }
  }, [address])

  const handleChange_value = useCallback((e) => {
    setgetBNB_value(e.target.value)
  }, [])

  const nextPrice = useMemo(() => getNextPrice(tokenPrice), [tokenPrice, getNextPrice])

  const walletSection = useMemo(
    () => (
      <div className="col-md-5 mt-4 mt-md-0">
        <div className="wallet_box presale-bg">
          <div className="top_widget">
            <div className="body_wigdet ss">
              <div className="d-flex text-center">
             {/*   <p className="white-paper"> 
      
              <a
                    href="https://polygonscan.com/token/0x9517Ca8c05F6d723796B896eEBA417d9c9Fe9999"
                    target="_blank" > Token Contract
                  </a> 
      
              </p> */}
              </div>
              <div className="d-flex justify-content-center mt-3 gap-4">
                <a href="https://www.dextools.io/app/en/polygon/pair-explorer/0xf3b4b58fd112b36e11c1f38790554b8753e2dd88?t=1755092421770">
                  <img src="/dex.png" alt="logo" />
                </a>
                <a href="https://app.uniswap.org/swap?chain=polygon&inputCurrency=0xc2132D05D31c914a87C6611C10748AEb04B58e8F&outputCurrency=0x88CE5800627f8706edf085Bee4fB0bDAF45B8888&value=10000&field=output">
                  <img src="/uniswap.png" alt="logo" />
                </a>
              </div>
              <br />
              <div className="d-flex justify-content-center mb-8 mt-8">
                <a href="https://app.uniswap.org/swap?chain=polygon&inputCurrency=0xc2132D05D31c914a87C6611C10748AEb04B58e8F&outputCurrency=0x88CE5800627f8706edf085Bee4fB0bDAF45B8888&value=10000&field=output">
                  <button className="button-5 w-100 sus py-2" style={{ color: '#22f4eb'}}>Buy on Uniswap</button>
                </a>
              </div>
              <br />
                <div className="d-flex justify-content-center mb-8 mt-8">
                <a href="https://www.dextools.io/app/en/polygon/pair-explorer/0xf3b4b58fd112b36e11c1f38790554b8753e2dd88?t=1755105358249">
                  <button className="button-5 w-100 sus py-2" style={{ color: '#00FF00' }}>Token Aggregator</button>
                </a>
              </div> 
              <br />
            <div className="d-flex justify-content-center mb-8 mt-8">
                <a href="https://polygonscan.com/token/0x88CE5800627f8706edf085Bee4fB0bDAF45B8888">
                  <button className="button-5 w-100 sus py-2" style={{ color: '#ffff00' }}>Contract of Token</button>
                </a>
              </div> 
            </div>
          </div>
        </div>
      </div>
    ),
    [
      address,
      chain,
      chains,
      data1,
      getBNB_value,
      getBalance,
      ipBalance,
      plan,
      raiseUsdt,
      soldTotal,
      showToken,
      spinner,
      staking_Amount,
      switchNetwork,
      tokenPrice,
      nextPrice,
      open,
    ],
  )

  const referralSection = useMemo(
    () => (
      <div className="referral-section">
        <h1 className="dashboard-heading" id="Referral">
          How To Buy
        </h1>
        <div className="steps-container">
          <div className="step-card step1">
            <FaWallet className="step-icon" />
            <h3 className="step-title">Step 1: Connect Your Wallet</h3>
            <p className="step-description">
              Ensure your wallet is connected to start participating in the DEXs.
            </p>
          </div>
          <div className="step-card step2">
            <FaShoppingCart className="step-icon" />
            <h3 className="step-title">Step 2: Buy Tokens</h3>
            <p className="step-description">
              Purchase tokens in DEXs using POLYGON or USDT and receive them instantly in
              your wallet, ready for using the token in projects!
            </p>
          </div>
          <div className="step-card step3">
            <FaShareAlt className="step-icon" />
            <h3 className="step-title">Step 3: Join Our Community</h3>
            <p className="step-description">
              Become a part of our community and invite your friends to join too!, so that the token will be grown and make profit to you.
            </p>
          </div>
        </div>
      </div>
    ),
    [],
  )

  return (
    <div className="LandingPage" id="Home">
      <div className="overlay"></div>
      <div className="container">
        <div className="row position-relative z-2 align-items-center justify-content-between">
          <div className="col-md-7">
            <h1 className="heading sss">ABOUT</h1>
            <h4 className="lower_head ss text-white">
              IP Token is a DeFi token on the Polygon (PoS) blockchain, designed as the core asset
              for the Intelligence Project (IP). With a 1 billion total supply and burnable
              features, it incorporates anti-bot and anti-whale mechanisms for fair trading. The
              staking system empowers the community, offering passive rewards and long-term growth
              opportunities.
            </h4>
            <br></br>
           {/* <a href="https://www.dextools.io/app/en/polygon/pair-explorer/0x091aa662db27ffb48c0fdaae2ba592bb6f2efb5c?t=1751987306780">
              <button className="button-5 mx-2" style={{ color: '#ffff00' }}>
                Dextools (Token Trade)
              </button>
            </a>
            <br></br> */}
            <br></br>
            <div className="lower_head ss">
              <span style={{ color: '#22f4eb' }}>IP DeFi Launch ! </span>
            </div>
            <br></br>
            <a href="https://defi.ip2025.biz">
              <button className="button-5 mx-2" style={{ color: '#ffff00' }}>
                Go To IP DeFi{' '}
              </button>
            </a>
          </div>
          {walletSection}
          {referralSection}
        </div>
      </div>
    </div>
  )
}
